import React from "react";
import { addAlpha } from "../../common/others/Functions";
import { DropOption, FlexRowBetween } from "../../common/Style";
import trash from "../../../assets/common/trash.svg";

const OWC = ({ setOwc, setShowDropOwc, top = "120%" }) => {
  return (
    <div
      style={{
        position: "absolute",
        left: "0",
        top,
        zIndex: 2,
        color: "#7b96c4",
        borderRadius: "5px",
        backgroundColor: "white",
        padding: "10px",
        fontSize: "12px",
        boxShadow: "0 2px 4px gray",
      }}
    >
      <FlexRowBetween>
        <DropOption
          background={addAlpha("#7b96c4", 0.2)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("בנם");
            setShowDropOwc(false);
          }}
        >
          בנם
        </DropOption>
        <DropOption
          background={addAlpha("#7b96c4", 0.2)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("בנה");
            setShowDropOwc(false);
          }}
        >
          בנה
        </DropOption>
        <DropOption
          background={addAlpha("#7b96c4", 0.2)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("בתו");
            setShowDropOwc(false);
          }}
        >
          בתו
        </DropOption>
        <DropOption
          background={addAlpha("#7b96c4", 0.2)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("בנו");
            setShowDropOwc(false);
          }}
        >
          בנו
        </DropOption>
        <DropOption
          background={"black"}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("קשר");
            setShowDropOwc(false);
          }}
          style={{ boxShadow: "0 2px 4px black" }}
        >
          <img src={trash} style={{ width: "15px" }} />
        </DropOption>
      </FlexRowBetween>
      <FlexRowBetween style={{ marginTop: "8px" }}>
        <DropOption
          background={addAlpha("#7b96c4", 0.2)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("בתם");
            setShowDropOwc(false);
          }}
        >
          בתם
        </DropOption>
        <DropOption
          background={addAlpha("#7b96c4", 0.2)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("בתה");
            setShowDropOwc(false);
          }}
        >
          בתה
        </DropOption>
        <DropOption
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("נכדה");
            setShowDropOwc(false);
          }}
        >
          נכדה
        </DropOption>
        <DropOption
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("נכדתם");
            setShowDropOwc(false);
          }}
        >
          נכדתם
        </DropOption>
      </FlexRowBetween>
      <FlexRowBetween style={{ marginTop: "8px" }}>
        <DropOption
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("נכדם");
            setShowDropOwc(false);
          }}
        >
          נכדם
        </DropOption>
        <DropOption
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("נכדתה");
            setShowDropOwc(false);
          }}
        >
          נכדתה
        </DropOption>
        <DropOption
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("נכדתו");
            setShowDropOwc(false);
          }}
        >
          נכדתו
        </DropOption>
        <DropOption
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("נכדו");
            setShowDropOwc(false);
          }}
        >
          נכדו
        </DropOption>
      </FlexRowBetween>
      <FlexRowBetween style={{ marginTop: "8px" }}>
        <DropOption
          style={{ color: "white" }}
          background={addAlpha("#7b96c4", 0.7)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("אחותה");
            setShowDropOwc(false);
          }}
        >
          אחותה
        </DropOption>
        <DropOption
          style={{ color: "white" }}
          background={addAlpha("#7b96c4", 0.7)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("אחותו");
            setShowDropOwc(false);
          }}
        >
          אחותו
        </DropOption>
        <DropOption
          style={{ color: "white" }}
          background={addAlpha("#7b96c4", 0.7)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("אחיו");
            setShowDropOwc(false);
          }}
        >
          אחיו
        </DropOption>
        <DropOption
          style={{ color: "white" }}
          background={addAlpha("#7b96c4", 0.7)}
          shadow={"#7b96c4"}
          onClick={() => {
            setOwc("אחיה");
            setShowDropOwc(false);
          }}
        >
          אחיה
        </DropOption>
      </FlexRowBetween>
    </div>
  );
};

export default OWC;
